import { constant } from './constant';

const local = 'analyseDashboard';

export const analyseDashboard = {
  companyPresentation: `${constant.route}${local}/companyPresentation.jpg`,
  wishesAndGoals: `${constant.route}${local}/wishesAndGoals.png`,
  financialHappiness: `${constant.route}${local}/financialHappiness.jpeg`,
};
